import SideloadCell from './component';
import { compose } from 'recompose';
import { connect } from 'react-redux';

import { withJourneyCardSelectors } from 'modules/journey/card/hoc';

const fields = ['extras', 'side_load_needed'];

const enhance = compose(
  withJourneyCardSelectors,
  connect((state, props) => {
    const { side_load_needed: sideloadNeeded, extras = [] } = props.selectors.getJourneyFields(
      state,
      props.journeyId,
      fields
    );
    return {
      sideloadNeeded: sideloadNeeded || extras.indexOf('SIDE_LOAD') >= 0,
    };
  })
);

export default enhance(SideloadCell);
